/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';

import { TemplatePlaceholderDto, TemplatePlaceholderFilterDto } from './template-placeholder.dto';

export const TemplatePlaceholderMapper = entity<TemplatePlaceholderDto>({});
export const TemplatePlaceholderFilterMapper = entity<TemplatePlaceholderFilterDto>({});
